import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  customCoverPage: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    paddingBottom: 0,
    flex: '1 1 auto',
    gap: '24px',
    '&.isFinalizedOrderPage': {
      padding: '0px',
    },
  },
  coverPagePreviewContainer: {
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    gap: '24px',
    felxWrap: 'wrap',
    '@media (min-width: 1080px)': {
      flexDirection: 'row',
    },
    '&.settingsDisabled': {
      border: 'none',
      padding: 0,
    },
  },
  checkChanges: {
    padding: 0,
  },
  descriptionText: {
    color: theme.evPalette.charcoal[800],
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    '& .value,&.value': {
      fontSize: '14px',
    },
  },
  inputTextField: {
    height: '44px',
    '&.select': {
      paddingTop: 0,
      paddingBottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
    '&.Mui-error > fieldset': { borderColor: `${theme.evPalette.rose[900]} !important` },
  },
  coverPageInputLabels: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    color: theme.evPalette.charcoal[800],
    '& >.myev-MuiFormLabel-asterisk': {
      color: theme.evPalette.rose[900],
    },
    '&.postalcode': {
      whiteSpace: 'nowrap',
    },
    '&.error': {
      color: theme.evPalette.rose[900],
    },
  },
  coverPageInformationTextStyles: {
    fontSize: '16px', fontWeight: 600, color: theme.evPalette.charcoal[800],
  },
  inputFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  coverPageTitleSubtitleContainer: {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    '@media(min-width: 1080px)': {
      flexDirection: 'row',
    },
  },
  inputStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '115px',
  },
  errorHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  coverPageInformationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  coverPageInformationFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
  },
  logoFileName: {
    color: theme.evPalette.charcoal[800],
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18px',
  },
  logoFileUploadError: {
    color: theme.evPalette.rose[900],
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  pageLayoutOptions: {
    justifyContent: 'space-between',
    '@media(min-width: 640px)': {
      justifyContent: 'unset',
      columnGap: '24px',
    },
  },
  logoFileInputLabel: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  linearProgressContainer: {
    height: 'fit-content',
    justifyContent: 'flex-start',
  },
  logoImage: {
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    width: 300,
    maxWidth: '100%',
  },
}));
